import Typography from '@/common/components/base/typography/Typography';
import { StepperProps } from '@/modules/adjusterReportModules/IncidentParticipants/components/common/Stepper.type';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { css } from 'styled-system/css';
import { Box } from 'styled-system/jsx';

const Stepper: React.FC<StepperProps> = ({
  steps,
  width: initialWidth = '100%',
}) => {
  const t = useLocation();
  const pathSegments = t.pathname.split('/');
  const lastSegment = pathSegments[pathSegments.length - 1];
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      width={initialWidth}
      maxWidth="maxContainer"
      mx="auto"
    >
      {steps.map((step, index) => {
        const isActive = lastSegment === steps[index].path;
        return (
          <React.Fragment key={step.label}>
            <Box
              display="flex"
              flexDir="column"
              justifyContent="space-between"
              alignItems="center"
              position="relative"
            >
              <Box display="flex" alignItems="center" gap="2">
                <Box
                  w={step.activeIcon ? 36 : 28}
                  h={step.activeIcon ? 36 : 28}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  borderRadius="full"
                >
                  {isActive ? step.activeIcon : step.icon}
                </Box>
              </Box>

              <Typography
                textStyle="b3"
                color="black-1"
                className={css({
                  position: 'absolute',
                  top: '35px',
                  left: '100%',
                  transform: 'translateX(-80%)',
                  textAlign: 'center',
                  width: 'fit-content',
                  whiteSpace: 'nowrap',
                })}
              >
                {step?.label}
              </Typography>
            </Box>
            {index < steps.length - 1 && (
              <Box
                flex="1"
                backgroundImage="url('@/common/assets/images/dashed-line.png')"
                backgroundSize="cover"
                height={2}
                mx={5}
              />
            )}
          </React.Fragment>
        );
      })}
    </Box>
  );
};
export default Stepper;
